import React from "react";
import { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addNewCountry } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import "./addCountry.css";

const AddCountry = () => {
  const [countryData, setCountryData] = useState({
    country_name: "",
    country_code: "",
    country_language_code: "",
    country_language_name: "",
    country_currency_symbol: "",
    country_phone_code: "",
    country_currency: "",
    country_flag: "",
    // country_having: "",
  });

  // const CountryHaving = {
  //   STATE: "states",
  //   CITY: "cities",
  //   REGION: "regions",
  //   PROVINCE: "province",
  // };

  // const dropdownOptions = ["REGION", "STATE", "PROVINCE", "CITY"];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!countryData.country_name?.trim()) {
      toast.error("Country Name is required");
      return;
    }
    if (!countryData.country_code?.trim()) {
      toast.error("Country ISO Code is required");
      return;
    }
    if (!countryData.country_language_name?.trim()) {
      toast.error("National Language is required");
      return;
    }
    if (!countryData.country_language_code?.trim()) {
      toast.error("Language Code is required");
      return;
    }
    if (!countryData.country_currency?.trim()) {
      toast.error("Country Currency is required");
      return;
    }
    if (!countryData.country_currency_symbol?.trim()) {
      toast.error("Currency Symbol is required");
      return;
    }
    if (!countryData.country_phone_code?.toString().trim()) {
      toast.error("Country Phone Code is required");
      return;
    }
    // if (!countryData.country_having?.trim()) {
    //   toast.error("Administrative Division is required");
    //   return;
    // }

    try {
      const response = await dispatch(addNewCountry(countryData));
      if (response.statusCode === 200) {
        navigate(-1);
      }
      setCountryData({
        country_name: "",
        country_code: "",
        country_language_code: "",
        country_language_name: "",
        country_currency_symbol: "",
        country_phone_code: "",
        country_currency: "",
        country_flag: "",
        // country_having: "",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setCountryData((prevData) => {
      let updatedData = { ...prevData, [name]: value };
      if (name === "country_code") {
        updatedData.country_flag = value.substring(0, 2).toLowerCase() + ".svg";
      }
      // if (name === "country_having") {
      //   updatedData.country_having = CountryHaving[value] || value;
      // }
      return updatedData;
    });
  };

  return (
    <MainLayout>
      <div className="acu-wrapper">
        {/* Header */}
        <div className="acu-header">
          <div className="acu-header-left">
            <div className="acu-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
              </svg>
            </div>
            <div>
              <h1 className="acu-title">Add Country</h1>
              <p className="acu-subtitle">Fill in the details to add a new country</p>
            </div>
          </div>
          <button onClick={() => navigate("/country")} className="acu-view-btn" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            View Country List
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="acu-form" noValidate>

          {/* Section 01 — Identity */}
          <div className="acu-section">
            <div className="acu-section-header">
              <span className="acu-section-badge">01</span>
              <h2 className="acu-section-title">Country Identity</h2>
            </div>
            <div className="acu-grid acu-grid-2">
              <div className="acu-field">
                <label className="acu-label">
                  Country Name <span className="acu-req">*</span>
                </label>
                <input
                  className="acu-input"
                  type="text"
                  name="country_name"
                  value={countryData.country_name}
                  onChange={handleAddChange}
                  placeholder="e.g. India"
                />
              </div>
              <div className="acu-field">
                <label className="acu-label">
                  Country ISO Code <span className="acu-req">*</span>
                </label>
                <input
                  className="acu-input"
                  type="text"
                  name="country_code"
                  value={countryData.country_code}
                  onChange={handleAddChange}
                  placeholder="e.g. IN"
                />
                {countryData.country_flag && (
                  <span className="acu-hint">
                    Flag file: <code className="acu-code">{countryData.country_flag}</code>
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Section 02 — Language */}
          <div className="acu-section">
            <div className="acu-section-header">
              <span className="acu-section-badge">02</span>
              <h2 className="acu-section-title">Language</h2>
            </div>
            <div className="acu-grid acu-grid-2">
              <div className="acu-field">
                <label className="acu-label">
                  National Language <span className="acu-req">*</span>
                </label>
                <input
                  className="acu-input"
                  type="text"
                  name="country_language_name"
                  value={countryData.country_language_name}
                  onChange={handleAddChange}
                  placeholder="e.g. Hindi"
                />
              </div>
              <div className="acu-field">
                <label className="acu-label">
                  Language Code <span className="acu-req">*</span>
                </label>
                <input
                  className="acu-input"
                  type="text"
                  name="country_language_code"
                  value={countryData.country_language_code}
                  onChange={handleAddChange}
                  placeholder="e.g. hi"
                />
              </div>
            </div>
          </div>

          {/* Section 03 — Currency */}
          <div className="acu-section">
            <div className="acu-section-header">
              <span className="acu-section-badge">03</span>
              <h2 className="acu-section-title">Currency</h2>
            </div>
            <div className="acu-grid acu-grid-2">
              <div className="acu-field">
                <label className="acu-label">
                  Country Currency <span className="acu-req">*</span>
                </label>
                <input
                  className="acu-input"
                  type="text"
                  name="country_currency"
                  value={countryData.country_currency}
                  onChange={handleAddChange}
                  placeholder="e.g. Indian Rupee"
                />
              </div>
              <div className="acu-field">
                <label className="acu-label">
                  Currency Symbol <span className="acu-req">*</span>
                </label>
                <input
                  className="acu-input"
                  type="text"
                  name="country_currency_symbol"
                  value={countryData.country_currency_symbol}
                  onChange={handleAddChange}
                  placeholder="e.g. ₹"
                />
              </div>
            </div>
          </div>

          {/* Section 04 — Contact & Division */}
          <div className="acu-section">
            <div className="acu-section-header">
              <span className="acu-section-badge">04</span>
              <h2 className="acu-section-title">Contact & Administrative Division</h2>
            </div>
            <div className="acu-grid acu-grid-2">
              <div className="acu-field">
                <label className="acu-label">
                  Country Phone Code <span className="acu-req">*</span>
                </label>
                <div className="acu-input-prefix-wrap">
                  <span className="acu-input-prefix">+</span>
                  <input
                    className="acu-input acu-input--prefixed"
                    type="number"
                    name="country_phone_code"
                    value={countryData.country_phone_code}
                    onChange={handleAddChange}
                    placeholder="e.g. 91"
                  />
                </div>
              </div>
              {/* <div className="acu-field">
                <label className="acu-label">
                  Administrative Division
                </label>
                <select
                  className="acu-select"
                  name="country_having"
                  value={
                    Object.keys(CountryHaving).find(
                      (key) => CountryHaving[key] === countryData.country_having
                    ) || ""
                  }
                  onChange={handleAddChange}
                >
                  <option value="">Select an option</option>
                  {dropdownOptions.map((option) => (
                    <option key={option} value={option}>
                      {CountryHaving[option].charAt(0).toUpperCase() + CountryHaving[option].slice(1)}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
          </div>

          {/* Footer */}
          <div className="acu-footer">
            <button
              type="button"
              className="acu-btn acu-btn--cancel"
              onClick={() => navigate("/country")}
            >
              Cancel
            </button>
            <button type="submit" className="acu-btn acu-btn--submit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Save Country
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddCountry;